module.exports = __webpack_public_path__ + "img/recruitecircle.c1c46950.png";